export const TextSkeletonComponent = {
  bindings: {
    width: '@?',
  },
  templateUrl: 'components/Skeletons/text-skeleton/text-skeleton.html',
};
